// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import { useLocation } from 'react-router';
import { useQuery } from '@apollo/client/react';
import { getStickers, findSticker } from './registry';
import Sticker from './Sticker';
import Promo from './Promo';
import { usePageData } from 'helpers/pageData';

import STICKER_COLLECTION_QUERY from 'queries/StickerCollection.graphql';

// Easter egg "My 80s Collection" (Plesk 18.0.80). Safe to drop with the egg.

const StickerCollectionGame = () => {
    const { pathname } = useLocation();
    const { pageSidebar } = usePageData();
    const { data } = useQuery(STICKER_COLLECTION_QUERY);

    if (!data) {
        return null;
    }

    const { viewer: { type, stickerCollection: { enabled, promoHidden, stickers: collectedStickers } } } = data;

    if (!enabled) {
        return null;
    }

    const isPowerUserPanel = !!pageSidebar?.isPowerUserPanel;

    const allStickers = getStickers(isPowerUserPanel, type);
    const sticker = findSticker(allStickers, pathname);

    if (!sticker) {
        return null;
    }

    const stickerIds = new Set(allStickers.map(item => item.id));
    const collectedCount = collectedStickers.filter((id: string) => stickerIds.has(id)).length;

    return (
        <>
            {sticker.entryPoint && (
                <Promo count={collectedCount} userType={type} promoHidden={promoHidden} />
            )}
            <Sticker
                key={sticker.id}
                sticker={sticker}
                collected={collectedStickers.includes(sticker.id)}
            />
        </>
    );
};

export default StickerCollectionGame;
